<template>
  <div class="container">
    <input
      multiple="true"
      style="opacity: 1"
      type="file"
      @input="importapp($event.target.files)"
      accept="application/JSON"
    />
  </div>
</template>

<script>
export default {
  computed: {
    returnobj() {
      return this.obj;
    },
  },
  props: {
    obj: { type: Object },
    type: { type: String },
  },
  methods: {
    importapp(files) {
      var reader = new FileReader();
      reader.onload = ((file) => {
        console.log(reader.readAsText(file));
        return (e) => {
          let data = JSON.parse(e.target.result);
          if (this.returnobj[data.name])
            data.name += "_" + new Date().toLocaleDateString();
          this.returnobj[data.name] = data;
          this.$emit("value", this.returnobj);
          return this.$store
            .dispatch("update", {
              type: "app",
              data: this.$store.state.app,
            })
        };
      })(files[0]);
    },
    upload(files) {
      console.log(files);
      this.$store
        .dispatch("import", { files, type: this.type })
        .then((d) => d());
    },
  },
};
</script>

<style lang="scss" scoped>
</style>